import styled from 'styled-components';
import { StyledButton as Button } from '../../../../../CommonComponents/Button';

export const StyledAlert = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  margin-bottom: 48px;

  &:after {
    content: '';
    position: absolute;
    right: -24px;
    left: 38px;
    bottom: -24px;
    border-bottom: 1px dashed #ddd;
  }

  &:last-of-type {
    margin-bottom: 0;

    &:after {
      border-bottom: none;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  margin: 0 12px;
`;

export const Sidebar = styled.div`
  color: #6C727F;
  font-size: 14px;

  i {
    color: #9c9c9c;
    margin-right: 0.5em;
  }
`;

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px;
`;

export const Date = styled.div``;

export const Label = styled.div`
  font-size: 14px;
  color: #6C727F;
  margin-bottom: 8px;
`;

export const StyledValue = styled.span`
  color: #333;
  font-weight: 600;
`;

export const StyledButton = styled(Button.Link)`
  font-size: 14px;
  font-weight: 600;
  color: #adadad;

  i {
    color: #c7c7c7;
  }
`;

export const Icon = styled.div`
  width: 32px;
  text-align: left;
`;
